<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fbITUN/tc-custom/9781512489330.jpg?1718162520525" alt="This image is the cover for the book Hanukkah Delight!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hanukkah Delight!
      </h1>
      <p class="bookDescription body article font2">
        <p>Whimsical bunnies celebrate Hanukkah in this charming rhyming board book describing all the Hanukkah rituals beloved by Jewish kids.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lesléa Newman, Amy Husband
      </h2>
      
      <p class="authorDescription body article"><B>Amy Husband</B> graduated from Liverpool School of Art with a B.A. in Graphic Art. Based in York, England, she loves illustrating children's books as well as drinking tea and eating biscuits.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Kar-Ben
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26b57706